export default {
	demosImageUrl(material) {

		var url = material.image
		
		return `https://vduris.eu/${url}`

		// if (
		// 	location.hostname === "localhost" ||
		// 	location.hostname === "127.0.0.1"
		// ) {
		// 	return `https://localhost:5001/${url}`
		// } else {
		// 	return `https://vduris.eu/images/${url}`
		// }
	}
};